<mat-card>
  <mat-card-header>
    <mat-card-title>Billing Reports</mat-card-title>
    <mat-card-subtitle>Monthly spreadsheet invoice and claim reports</mat-card-subtitle>
  </mat-card-header>
  <div class="table-container">
    <mat-table [dataSource]="reports" class="mat-elevation-z8">
      <ng-container matColumnDef="invoice">
        <mat-header-cell *matHeaderCellDef> Date </mat-header-cell>
        <mat-cell *matCellDef="let report"> {{ report.invoice }} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="url">
        <mat-header-cell *matHeaderCellDef> Invoice </mat-header-cell>
        <mat-cell *matCellDef="let report">
          <button
            type="button"
            class="button-actions"
            mat-icon-button
            [color]="report.url ? 'accent' : ''"
            [disabled]="!report.url"
            [matTooltip]="report.url ? 'Download Invoice' : 'No invoice available'"
            (click)="openUrl(report.url)"
          >
            <mat-icon>download</mat-icon>
          </button>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="claimUrl">
        <mat-header-cell *matHeaderCellDef> Claim Report </mat-header-cell>
        <mat-cell *matCellDef="let report">
          <button
            type="button"
            class="button-actions"
            mat-icon-button
            [color]="report.claimUrl ? 'accent' : ''"
            [disabled]="!report.claimUrl"
            [matTooltip]="report.claimUrl ? 'Download Claim Report' : 'No claim report available'"
            (click)="openClaimReport(report.idDoc)"
          >
            <mat-icon>download</mat-icon>
          </button>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
    <mat-paginator [pageSize]="6" [pageSizeOptions]="[6, 12, 18]"></mat-paginator>
  </div>
</mat-card>
